import {$getModuleColor, $getModuleIcon} from "./appModules"

export const sidebarMenu: SidebarMenu = [
    {
        title: 'default',
        menu: [
            {
                title: 'menu.dashboard',
                path: '/service',
                icon: $getModuleIcon('dashboard'),
                module: 'dashboard',
            },
            {
                title: 'menu.processes',
                path: '/service/processes',
                icon: $getModuleIcon('processes'),
                color: $getModuleColor('processes'),
                ability: ['viewAny', 'processes'],
                module: 'processes',
            },
            {
                title: 'menu.payment',
                path: '/service/payments/paymentRuns',
                icon: $getModuleIcon('payments'),
                color: $getModuleColor('payments'),
                ability: ['viewAny', 'payments'],
                module: 'payments',
            },
            {
                title: 'menu.settings',
                path: '/service/settings',
                icon: $getModuleIcon('settings'),
                color: $getModuleColor('settings'),
                module: 'settings',
                children: [
                    {
                        title: 'menu.users',
                        path: '/service/settings/users',
                        ability: ['viewAny', 'users'],
                        module: 'users',
                    },
                    {
                        title: 'menu.organisations',
                        path: '/service/settings/organisations',
                        ability: ['viewAny', 'organisations'],
                        module: 'organisations',
                    },
                ]
            },
            {
                title: 'menu.basicData',
                path: '/service/basicData',
                icon: $getModuleIcon('basicData'),
                color: $getModuleColor('basicData'),
                ability: ['viewAny', 'basicData'],
                module: 'basicData',
                children: [
                    {
                        title: 'menu.fundingPrograms',
                        path: '/service/basicData/fundingPrograms',
                        ability: ['viewAny', 'fundingPrograms'],
                        module: 'basicData',
                    },
                    {
                        title: 'menu.forms',
                        path: '/service/basicData/forms',
                        ability: ['viewAny', 'forms'],
                        module: 'basicData',
                    },
                    {
                        title: 'menu.categories',
                        path: '/service/basicData/categories',
                        ability: ['viewAny', 'categories'],
                        module: 'basicData'
                    },
                    {
                        title: 'menu.statuses',
                        path: '/service/basicData/statuses',
                        ability: ['viewAny', 'statuses'],
                        module: 'basicData'
                    },
                    {
                        title: 'menu.roles',
                        path: '/service/basicData/roles',
                        ability: ['update', 'roles'],
                        module: 'basicData'
                    },
                    {
                        title: 'menu.years',
                        path: '/service/basicData/years',
                        ability: ['viewAny', 'years'],
                        module: 'basicData'
                    },
                    {
                        title: 'menu.mailTemplates',
                        path: '/service/basicData/mailTemplates',
                        ability: ['viewAny', 'mailTemplates'],
                        module: 'mailTemplates'
                    },
                    {
                        title: 'menu.mails',
                        path: '/service/basicData/mails',
                        ability: ['viewAny', 'mails'],
                        module: 'mails'
                    }
                ]
            },
        ]
    },
]